import { render } from "./DeleteGoalsModal.vue?vue&type=template&id=65b084bf"
import script from "./DeleteGoalsModal.vue?vue&type=script&lang=js"
export * from "./DeleteGoalsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__